export default __webpack_public_path__ + "static/media/01_Kom_Blockhaus.2642531c.jpg";